import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as classnames from 'classnames'

import { FirestoreRepository } from '../../../commons/repository/FirestoreRepository'
import { ACCESS_TOKEN, LP_IMAGE_URL } from '../../../commons/Const'
import PresentationControllerPage from '../PresentationControllerPage/PresentationControllerPage'
import PrePresentationNotification from '../../components/organisms/PrePresentationNotification/PrePresentationNotification'
import PresentationTitle from '../../components/organisms/PresentationTitle/PresentationTitle'
import QuestionPrepare from '../../components/organisms/QuestionPrepare/QuestionPrepare'
import Question from '../../components/organisms/Question/Question'
import Ranking from '../../components/organisms/Ranking/Ranking'
import * as QuizPhase from '../../../commons/QuizPhase'
import {
  RECEIVE_CHANGE_PARTICIPANT,
  RECEIVE_CHANGE_STATUS,
  FETCH_PROJECT,
  FETCH_RANKING,
  FETCH_ANSWER_COUNT
} from '../../actions/presentationActions'
import SpinnerWithLabel from '../../components/molecules/SpinnerWithLabel/SpinnerWithLabel'

import './PresentationPage.css'
import { QuizType } from '../../../commons/EditorStatus'
import {
  getParams,
  buildJoinUrl,
  buildJoinQueryString,
  getStorage,
  flatten,
  setStorage,
  removeStorage
} from '../../../commons/utils'
import ImagePreloader from '../../components/atoms/ImagePreloader/ImagePreloader'
import { isMobile, isMobileOnly } from 'react-device-detect'

const END_TIME_KEY = 'presentation_end_time'

class PresentationPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      lastFetchAnswerCountTime: 0,
      time: null,
      isWatchingFirestore: false
    }
  }
  componentDidMount() {
    this.props.fetchProject(getParams().env)
  }

  render() {
    const {
      index,
      phase,
      type,
      answerCount,
      project,
      questions,
      title,
      image,
      participantCount,
      shareParam,
      ranking,
      isRankingFetching,
      isRankingFetched,
      recieveChangeStatus,
      recieveChangeParticipant,
      fetchRanking,
      fetchAnswerCount,
      isPresentationLoading
    } = this.props

    if (!project.id) {
      return (
        <div styleName="loading">
          <SpinnerWithLabel />
        </div>
      )
    }

    if (!this.state.isWatchingFirestore) {
      const firestoreRepository = new FirestoreRepository()
      firestoreRepository.watchPresentationQuizStatus(project.room_id, data => {
        recieveChangeStatus(data)
      })
      firestoreRepository.watchPresentationParticipant(project.room_id, () => {
        recieveChangeParticipant()
      })
      this.setState({
        isWatchingFirestore: true
      })
    }

    let contents
    if (type === QuizType.NOTIFICATION.value) {
      contents = (
        <PrePresentationNotification
          env={getParams().env}
          isHeadlessController={isMobile}
          token={getStorage(ACCESS_TOKEN) || getParams().token}
        />
      )
    } else if (type === QuizType.FIRSTPAGE.value) {
      contents = (
        <PresentationTitle
          title={title}
          image={image || LP_IMAGE_URL}
          participantCount={participantCount}
          shareUrl={
            shareParam
              ? buildJoinUrl(
                  `?${buildJoinQueryString({
                    share_param: shareParam
                  })}`
                )
              : null
          }
        />
      )
    } else if (type === QuizType.RANKING.value || type === QuizType.COMPLETE.value) {
      // クイズが終わった後、ランキング画面に遷移. クイズ完了後も1位を一旦映し続ける.
      if (!isRankingFetching && !isRankingFetched) {
        fetchRanking({ projectId: project.id })
      }
      contents = <Ranking index={index} ranking={ranking} isLoading={isPresentationLoading} />
    } else {
      // phaseによって出すcontentsを変更
      const question = questions[index]
      switch (phase) {
        case QuizPhase.PREPARE:
          contents = <QuestionPrepare>{`第${index + 1}問`}</QuestionPrepare>
          break
        case QuizPhase.QUESTION:
          contents = <Question question={question} index={index} isHidden={true} />
          removeStorage(END_TIME_KEY)
          break
        case QuizPhase.START:
          // 定期的に更新させる
          // setStateが実行されると、stateが更新されるため、もう一度renderされることを生かしてsetTimeoutで行っている
          if (!getStorage(END_TIME_KEY)) {
            setStorage(END_TIME_KEY, Date.now() / 1000 + (question ? question.limit_time : 0))
          }

          this.timeout = setTimeout(() => {
            this.setState({ time: getStorage(END_TIME_KEY) - Date.now() / 1000 })
          }, 0.2 * 1000)

          if (
            this.state.time &&
            Math.ceil(this.state.time % 3) === 1 &&
            this.state.time != 0 &&
            this.state.lastFetchAnswerCountTime !== Math.ceil(this.state.time)
          ) {
            this.setState({ lastFetchAnswerCountTime: Math.ceil(this.state.time) })
            if (question) {
              fetchAnswerCount({ projectId: project.id, questionId: question.id, env: getParams().env })
            }
          }
          contents = (
            <Question
              question={question}
              index={index}
              time={this.state.time || (question ? question.limit_time : 0)}
              answerCount={answerCount}
            />
          )
          break
        case QuizPhase.TIMEOUT:
          contents = <Question question={question} index={index} isTimeup={true} answerCount={answerCount} />
          clearTimeout(this.timeout)
          removeStorage(END_TIME_KEY)
          this.setState({ time: null })
          break
        case QuizPhase.ANSWER_COUNT:
          contents = (
            <Question
              question={question}
              index={index}
              isTimeup={true}
              showAnswerCount={true}
              answerCount={answerCount}
            />
          )
          break
        case QuizPhase.IS_ANSWER:
          contents = <QuestionPrepare>正解は？</QuestionPrepare>
          break
        case QuizPhase.RESULT:
          contents = (
            <Question
              question={question}
              index={index}
              isTimeup={true}
              showAnswerCount={true}
              showAnswer={true}
              answerCount={answerCount}
            />
          )
          break
      }
    }

    return (
      <div styleName="container">
        <div
          styleName={isMobileOnly ? 'sp-container' : 'fullwidth'}
          style={{ transform: isMobileOnly ? `scale(calc(${window.innerWidth - 24}/960))` : null }}
        >
          {contents}
        </div>
        <ImagePreloader images={flatten(questions.map(question => question.choices.map(choice => choice.image)))} />
        {isMobile ? (
          <div styleName={classnames({ controller: true, spController: isMobileOnly })}>
            <PresentationControllerPage isContainerPage />
          </div>
        ) : null}
      </div>
    )
  }
}

PresentationPage.propTypes = {
  // Socket
  index: PropTypes.number.isRequired,
  phase: PropTypes.number,
  type: PropTypes.number,
  participantCount: PropTypes.number,
  answerCount: PropTypes.number,
  image: PropTypes.string,
  // API
  project: PropTypes.object,
  questions: PropTypes.array.isRequired,
  title: PropTypes.string,
  shareParam: PropTypes.string.isRequired,
  ranking: PropTypes.array,
  isPresentationLoading: PropTypes.bool.isRequired,
  isRankingFetching: PropTypes.bool.isRequired,
  isRankingFetched: PropTypes.bool.isRequired,
  paidFlag: PropTypes.bool,
  // dispatch
  recieveChangeStatus: PropTypes.func.isRequired,
  recieveChangeParticipant: PropTypes.func.isRequired,
  fetchProject: PropTypes.func.isRequired,
  fetchRanking: PropTypes.func.isRequired,
  fetchAnswerCount: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  return {
    phase: state.presentation.phase,
    index: state.presentation.index,
    type: state.presentation.type,
    image: state.presentation.project.image,
    answerCount: state.presentation.answerCount,
    participantCount: state.presentation.participantCount,
    project: state.presentation.project,
    title: state.presentation.project.presentation_title,
    shareParam: state.presentation.project.share_param,
    questions: state.presentation.project.questions,
    paidFlag: state.presentation.project.paid,
    ranking: state.presentation.ranking,
    isPresentationLoading: state.presentation.isPresentationLoading,
    isRankingFetching: state.presentation.isRankingFetching,
    isRankingFetched: state.presentation.isRankingFetched
  }
}

const mapDispatchToProps = dispatch => ({
  fetchProject: env => dispatch(FETCH_PROJECT(env)),
  fetchRanking: data => dispatch(FETCH_RANKING(data)),
  fetchAnswerCount: data => dispatch(FETCH_ANSWER_COUNT(data)),
  recieveChangeStatus: status => dispatch(RECEIVE_CHANGE_STATUS(status)),
  recieveChangeParticipant: () => dispatch(RECEIVE_CHANGE_PARTICIPANT())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationPage)
